export default __webpack_public_path__ + "static/media/temp-2.f9650626.svg";